import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import services from "../services";

interface AllLogUsers {
  data: any[];
  loading: boolean;
  error: boolean;
}

const initialState: AllLogUsers = {
  data: [],
  loading: false,
  error: false,
};

const AllLogUsersSlice = createSlice({
  name: "allUsers",
  initialState,
  reducers: {
    getAllLogUsers: (state) => {
      state.loading = true;
      state.error = false;
      state.data = [];
    },
    getAllLogUsersSuccess: (state, action: PayloadAction<string[]>) => {
        state.loading = false;
        state.error = false;
        state.data = action.payload;
      },
    getAllLogUsersFailure: (state) => {
      state.loading = false;
      state.error = true;
      state.data = [];
    },
  },
});

export const { getAllLogUsers, getAllLogUsersSuccess, getAllLogUsersFailure } =
AllLogUsersSlice.actions;

export default AllLogUsersSlice.reducer;

export const fetchAllLogUsers = () => async (dispatch: any) => {
    dispatch(getAllLogUsers());
    try {
      const response = await services.getAllLogUsers();
        dispatch(getAllLogUsersSuccess(response.users));
    } catch (err) {
      console.error("Erro ao buscar usuários do log:", err);
      dispatch(getAllLogUsersFailure());
    }
  };

